import React, { useState, useEffect } from 'react';
import useImage from '../../common/images/useImage';
import CGISpinner from '../../common/images/cgiSpinner/CGISpinner';
import CrossfadeImage from '../crossfadeImage/CrossfadeImage';
import FallbackCgi from '../../common/cgi/FallbackCgi';
import { connect } from 'react-redux';
import { useTranslate } from '../../../core/translate';

const InteriorCgi = (props) => {
  const { cgi, onClick } = props;
  const { url, dimensions } = cgi;
  const { hasLoaded, hasError } = useImage(url);
  const [isLoaded, setIsLoaded] = useState(false);
  const [image, setImage] = useState(null);
  const [breakpoint, setBreakpoint] = useState(null);
  const translate = useTranslate();
  const imageAlt = translate('interior');

  useEffect(() => {
    if (hasLoaded) {
      setImage(url);
      setIsLoaded(true);
    } else {
      if (props.breakpoint !== breakpoint) {
        setBreakpoint(props.breakpoint);
        setIsLoaded(false);
      }
    }
  }, [hasLoaded]);

  if (hasError) {
    return <FallbackCgi fullSize />;
  }

  if (!isLoaded) {
    return (
      <CGISpinner
        className="interior__cgi-spinner"
        width={dimensions.width}
        height={dimensions.height}
      />
    );
  }

  return (
    <>
      {isLoaded && (
        <CrossfadeImage
          src={image}
          duration={500}
          delay={200}
          timingFunction={'ease-out'}
          containerClass="interior-cgi-crossfade"
          imageClass="interior-cgi-crossfade-img"
          alt={imageAlt}
          onClick={onClick}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { breakpoint } = state;

  return {
    breakpoint,
  };
};

export default connect(mapStateToProps)(InteriorCgi);
